import { useTableMasterService } from "@/hooks/useMasterTableService";
import { useParameterTableService } from "@/hooks/useParameterTableService";
import type { ParameterTableMap, RecordItemMap, ResultMasterMap } from "@/interfaces/table-master";
import { FILTER_TYPES_MASTER } from "@/types/master-filter";
import { getRecordsTableMasterByCode, getValueRecordTableMasterBycode } from "@/utils/commoms";
import {
    createContext,
    useContext,
    useMemo,
    type ReactNode,
    type FC,
    useCallback
} from "react";

interface MasterTableContextState {
    masterTable: ResultMasterMap[];
    parametersTable: ParameterTableMap[];
    getRecordsMasterTable?: (codeTable: number) => RecordItemMap[];
    getValueByCodeMasterTable?: (codeTable: number, codeRecord: number) => string;
    loadTableMasterAndParameterData?: () => void;
}

const MasterTableContext = createContext<MasterTableContextState | undefined>(undefined);

interface MasterTableProviderProps {
    children: ReactNode;
}

export const MasterTableProvider: FC<MasterTableProviderProps> = ({ children }) => {

    const { data: masterTableData, refetch: refetchTableMaster } = useTableMasterService({ type: FILTER_TYPES_MASTER.MASTER }, { enabled: false });
    const { data: parameterTableData, refetch: refetchParameterTable } = useParameterTableService({ type: FILTER_TYPES_MASTER.PARAMETERS }, { enabled: false });
    const loadTableMasterAndParameterData = useCallback(async () => {
        refetchTableMaster();
        refetchParameterTable();
    }, [refetchTableMaster, refetchParameterTable])

    const value = useMemo(
        () => ({
            masterTable: masterTableData? masterTableData : [],
            parametersTable: parameterTableData? parameterTableData : [],
            loadTableMasterAndParameterData,
            getRecordsMasterTable: (codeRegister: number) => getRecordsTableMasterByCode(masterTableData, codeRegister),
            getValueByCodeMasterTable: (codeRegister: number, codeRecord: number) => getValueRecordTableMasterBycode(masterTableData, codeRegister, codeRecord)
        }),
        [masterTableData, parameterTableData , loadTableMasterAndParameterData]
    );

    return <MasterTableContext.Provider value={value}>{children}</MasterTableContext.Provider>;
};

export const useMasterTable = (): MasterTableContextState => {
    const context = useContext(MasterTableContext);
    if (!context) {
        throw new Error("useMasterTable debe ser usado con MasterTableProvider");
    }
    return context;
};